// extracted by mini-css-extract-plugin
module.exports = {"activate-all-rates-title":"activationRatesList_activate-all-rates-title__1VI64"};